import CustomTable from '../../../../../v2-components/Antd/Table';
import { columnsDefinition } from './constants/columns-definiton.constant';
import './style.scss';

export default function PharmacyLocalsListTable(props) {
	const { onPageChange, dataSource, pagination, loading, error, tableProps } = props;
	const rowKey = '_id';

	const paginationConfig = {
		current: pagination.currentPage,
		pageSize: pagination.pageSize,
		total: pagination.totalItems,
		showSizeChanger: false,
		onChange: (page) => onPageChange(page),
		position: ['bottomLeft'],
	};
	const localeConfig = {
		emptyText: error ? 'Lo siento... tuvimos un problema trayendo los datos' : null,
	};

	return (
		<div className="own-pharmacy-locals-list-view">
			<CustomTable
				dataSource={dataSource}
				columns={columnsDefinition}
				loading={loading}
				pagination={paginationConfig}
				rowKey={rowKey}
				locale={localeConfig}
				{...tableProps}
			/>
		</div>
	);
}
